import React, { useMemo } from 'react';
import UIStrings from '@/Utils/UIStrings';
import AdvancedFilterButton from '../../../../Overview/Components/Filter/AdvancedFilterButton';
import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import { useIdentifiedProfilesCompanyFilters } from '../../../api/useIdentifiedProfiles';

const CompanyNameFilter = () => {
    const { options, setOptions } = useIdentifiedListContext();
    const { data } = useIdentifiedProfilesCompanyFilters();
    const resetCallback = () => setOptions((p) => ({ ...p, filters: { ...p.filters, companyId: undefined } }));

    const menuItems = useMemo<Parameters<typeof AdvancedFilterButton>['0']['menuItems']>(
        () =>
            data?.map(({ id, name, count }) => ({
                id,
                selected: !!options.filters?.companyId?.find((selectedCompany) => selectedCompany === id),
                changeCallback: () => {
                    const foundIndex = options.filters?.companyId?.findIndex(
                        (selectedCompany) => selectedCompany === id,
                    );

                    if (typeof foundIndex === 'number' && foundIndex > -1) {
                        setOptions((p) => ({
                            ...p,
                            filters: {
                                ...p.filters,
                                companyId: p.filters?.companyId?.toSpliced(foundIndex, 1),
                            },
                        }));
                    } else {
                        setOptions((p) => ({
                            ...p,
                            filters: {
                                ...p.filters,
                                companyId: p.filters?.companyId?.toSpliced(0, 0, id) || [id],
                            },
                        }));
                    }
                },
                menuItemLabel: `${name} (${count})`,
            })) || [],
        [data, options, setOptions],
    );

    return <AdvancedFilterButton label={UIStrings.CompanyName} menuItems={menuItems} resetCallback={resetCallback} />;
};

export default CompanyNameFilter;
